import { render, staticRenderFns } from "./unqualifiedRegisterHistory.vue?vue&type=template&id=b657d16a&scoped=true"
import script from "./unqualifiedRegisterHistory.vue?vue&type=script&lang=js"
export * from "./unqualifiedRegisterHistory.vue?vue&type=script&lang=js"
import style0 from "./unqualifiedRegisterHistory.vue?vue&type=style&index=0&id=b657d16a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b657d16a",
  null
  
)

export default component.exports